import type { RenderContext, RenderField } from "../types.ts";
import { renderTextLikeField } from "./text-input.ts";

export const renderPhoneField = (
  field: RenderField<"PHONE">,
  context: RenderContext,
): HTMLElement => {
  return renderTextLikeField(field, context, "tel");
};
